import { MapPin, Phone, Mail, Clock, Star } from "lucide-react";
import { CLINIC_NAP } from "@/data/cities";
import { WHATSAPP_LINK } from "@/lib/api";

/**
 * NAP (Name / Address / Phone) block — for local SEO consistency.
 * Rendered identically wherever it's used (footer, contact, city pages).
 */
export default function NAPBlock({ compact = false }) {
  if (compact) {
    return (
      <div data-testid="nap-block" className="text-sm space-y-2">
        <div className="font-serif text-lg tracking-tightest text-ink">{CLINIC_NAP.name.split("—")[0].trim()}</div>
        <div className="text-ink-muted">
          {CLINIC_NAP.streetAddress}, {CLINIC_NAP.addressLocality}, {CLINIC_NAP.addressRegion} {CLINIC_NAP.postalCode}
        </div>
        <div className="flex flex-wrap gap-4 text-ink-muted">
          <a href={WHATSAPP_LINK()} target="_blank" rel="noreferrer" className="hover:text-ink">{CLINIC_NAP.telephone}</a>
          <a href={`mailto:${CLINIC_NAP.email}`} className="hover:text-ink">{CLINIC_NAP.email}</a>
        </div>
      </div>
    );
  }
  return (
    <div data-testid="nap-block" className="hairline bg-white/60 p-6 md:p-8 grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <div className="kbd">Practice</div>
        <div className="mt-2 font-serif text-2xl tracking-tightest text-ink leading-snug">
          Dr Tegbir Vascular
        </div>
        <div className="mt-1 text-sm text-ink-muted">Interventional Radiology · Vascular & Endovascular</div>
      </div>
      <div className="space-y-3 text-sm">
        <div className="flex items-start gap-3">
          <MapPin size={14} className="mt-0.5 text-crimson" />
          <div>
            <div className="text-ink">{CLINIC_NAP.streetAddress}</div>
            <div className="text-ink">{CLINIC_NAP.addressLocality}, {CLINIC_NAP.addressRegion} {CLINIC_NAP.postalCode}</div>
          </div>
        </div>
        <div className="flex items-start gap-3">
          <Phone size={14} className="mt-0.5 text-crimson" />
          <a href={WHATSAPP_LINK()} target="_blank" rel="noreferrer" className="text-ink hover:text-crimson">{CLINIC_NAP.telephone}</a>
        </div>
        <div className="flex items-start gap-3">
          <Mail size={14} className="mt-0.5 text-crimson" />
          <a href={`mailto:${CLINIC_NAP.email}`} className="text-ink hover:text-crimson">{CLINIC_NAP.email}</a>
        </div>
        <div className="flex items-start gap-3">
          <Clock size={14} className="mt-0.5 text-crimson" />
          <span className="text-ink">Mon–Sat · 09:00–18:00 IST</span>
        </div>
        {(CLINIC_NAP.gbpShareUrl || CLINIC_NAP.gbpUrl) && (
          <div className="flex items-start gap-3 pt-2 mt-2 border-t border-black/10">
            <Star size={14} className="mt-0.5 text-crimson" />
            <a href={CLINIC_NAP.gbpShareUrl || CLINIC_NAP.gbpUrl} target="_blank" rel="noreferrer" data-testid="gbp-link" className="text-ink hover:text-crimson">
              View on Google · Reviews & directions
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
